import React, { FC } from 'react';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';
import useAppSelector from '../hooks/useAppSelector';
import Modal from './common/Modal/Modal';
import useMaxAmountOfTokens from '../hooks/common/useMaxAmountOfTokens';

interface ModalOverMaxAmountProps {
  isShow: boolean;
  onRequestClose: () => void;
}

const ModalOverMaxAmount: FC<ModalOverMaxAmountProps> = ({
  isShow,
  onRequestClose,
}) => {
  const { selectedToken } = useAppSelector(selectBridgeSlice);
  const maxAmountOfTokens = useMaxAmountOfTokens(
    selectedToken ? selectedToken?.symbol : `KSTA`,
  );

  return (
    <Modal
      size="sm"
      isShow={isShow}
      onClose={onRequestClose}
      title=" "
      explanation={
        <>
          If you want to convert more than{` `}
          {maxAmountOfTokens}, please contact us through the K STADIUM Help
          Center before proceeding with the conversion.
        </>
      }
      footerComponent={
        <button
          onClick={() => {
            onRequestClose();
          }}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    />
  );
};

export default ModalOverMaxAmount;
